const initPardotCookieBar = () => {
    // const acceptCookieCheckbox = document.querySelector(
    //     ".gg-attestation__privacy-check",
    // );

    // if (!acceptCookieCheckbox) {
    //     return;
    // }

    // Function to trigger click on 'pi_tracking_opt_in_yes' if it exists
    const triggerOptInClick = () => {
        const optInElement = document.getElementById("pi_tracking_opt_in_yes");
        if (optInElement) {
            optInElement.click();
        }
    };

    // Check and handle the initial state of the checkbox
    // if (acceptCookieCheckbox.checked) {
    //     triggerOptInClick();
    // }

    // // Listen for changes on the checkbox
    // acceptCookieCheckbox.addEventListener("change", (event) => {
    //     if (event.target.checked) {
    //         triggerOptInClick();
    //     }
    // });

    const checkOneTrust = setInterval(() => {
        if (typeof window.OneTrust !== 'undefined') {
            if(window.OnetrustActiveGroups.indexOf('C0002') > 0) {
                triggerOptInClick();
                clearInterval(checkOneTrust);
            }
            window.OneTrust.OnConsentChanged(function () {
                if(typeof OneTrust !== 'undefined' && window.OnetrustActiveGroups.indexOf('C0002') > 0){
                    triggerOptInClick();
                }
            });
            clearInterval(checkOneTrust); // Stop checking once OneTrust is available
        }
    }, 400); // Check every 100ms
};

export default initPardotCookieBar;
